export default "__VITE_ASSET__C4gcTjQ4__"